// extracted by mini-css-extract-plugin
module.exports = {"modalLoader":"_loaders_modalLoader__3EVxu","pageLoader":"_loaders_pageLoader__2H4Ls"};